(function() {
	if(typeof __webpack_require__ !== "undefined") {
	                        if (typeof globalThis !== "undefined" && globalThis._base) {
	                            __webpack_require__.p = _base
	                        }
	                    }
})()